import get from 'lodash.get';
import { localStorage, sessionStorage } from 'dibs-browser-storage';
import { PAGE_TYPE } from '../../../utils/pageConstants';
import isPageType from '../../../utils/isPageType';
import { STORAGE } from '../../../utils/checkoutStorageConstants';
import checkoutSurveyLauncher from './checkoutSurveyLauncher';
import makeOfferLauncher from '../../../../exports/makeOfferLauncher';
import MODAL_STEP from '../../../contactModal/json/modalStepTypes.json';

const thirtyMinutesPassed = time => {
    const date = new Date(time);
    return (Date.now() - date.getTime()) / (1000 * 60) >= 0.01;
};

const isBlacklistedPage = isPageType([PAGE_TYPE.CHECKOUT, PAGE_TYPE.ABOUT]);

const preAuthOfferModal = () => dispatch => {
    const preAuthOfferModalInfo = localStorage.getItem('checkoutPreAuthOfferModalInfo');
    const surveyInfo = localStorage.getItem(STORAGE.SURVEY_INFO);
    if (preAuthOfferModalInfo) {
        const {
            itemId,
            offerAmount,
            offerCurrency,
            offerMessage,
            sellerId,
            quantity,
            name,
        } = preAuthOfferModalInfo;
        makeOfferLauncher({
            item: {
                id: itemId,
                seller: {
                    id: sellerId,
                },
            },
            currency: offerCurrency,
            currentStep: MODAL_STEP.ABANDON_MAKE_OFFER,
            preloadedState: {
                fields: {
                    offerFieldValue: offerAmount,
                    messageFieldValue: offerMessage,
                    nameFieldValue: name,
                    quantityFieldValue: quantity,
                },
            },
        });
        localStorage.setItem('hasSeenPreAuthOfferModal', { itemId });
        dispatch({ type: 'noop' });
    }
    if (surveyInfo) {
        checkoutSurveyLauncher();
        dispatch({ type: 'noop' });
    }
};

const preAuthOfferModalAndSurveyRule = function preAuthOfferModalAndSurveyRule() {
    if (isBlacklistedPage) {
        return Promise.resolve(false);
    }

    let isAfterTimer;

    // checkoutPreAuthOfferModal display logic
    // if checkoutPreAuthOfferModalInfo is present, it overrides checkoutSurveyInfo
    const preAuthOfferModalInfo = localStorage.getItem('checkoutPreAuthOfferModalInfo');
    if (preAuthOfferModalInfo) {
        const { itemId } = preAuthOfferModalInfo;
        const hasSeenPreAuthOfferModal =
            itemId === get(localStorage.getItem('hasSeenPreAuthOfferModal'), 'itemId');

        isAfterTimer = thirtyMinutesPassed(preAuthOfferModalInfo.checkoutTime);

        if (!isAfterTimer && !hasSeenPreAuthOfferModal) {
            return Promise.resolve(true);
        }
    }

    // Old checkout survey
    const surveyInfo = localStorage.getItem(STORAGE.SURVEY_INFO);
    const hasSeenSurvey = !!localStorage.getItem('hasSeenCheckoutSurvey');
    if (surveyInfo && !hasSeenSurvey) {
        isAfterTimer = thirtyMinutesPassed(surveyInfo.checkoutTime);
        if (!isAfterTimer) {
            return Promise.resolve(true);
        }
    }

    return Promise.resolve(false);
};

const autoModalRule = function autoModalRule() {
    const autoModalInfo = sessionStorage.getItem(STORAGE.AUTO_MODAL_INFO);
    return Promise.resolve(!isBlacklistedPage && autoModalInfo);
};

export default [
    {
        name: 'preAuthOfferModal',
        rule: preAuthOfferModalAndSurveyRule,
        action: preAuthOfferModal,
        priority: 100,
    },
    {
        name: 'autoModal',
        rule: autoModalRule,
        action: () => dispatch => {
            import(/* webpackChunkName: "abandonCheckoutAutoModal" */
            './autoModalAction').then(({ default: autoModal }) => autoModal(dispatch));
        },
        priority: 350,
    },
];
